export default {

  FETCH_QUICK_NUMBERS: '@DASHBOARD/FETCH_QUICK_NUMBERS',
  FETCH_QUICK_NUMBERS_SUCCESS: '@DASHBOARD/FETCH_QUICK_NUMBERS_SUCCESS',
  FETCH_QUICK_NUMBERS_FAILURE: '@DASHBOARD/FETCH_QUICK_NUMBERS_FAILURE',

  FETCH_EVENTS: '@DASHBOARD/FETCH_EVENTS',
  FETCH_EVENTS_SUCCESS: '@DASHBOARD/FETCH_EVENTS_SUCCESS',
  FETCH_EVENTS_FAILURE: '@DASHBOARD/FETCH_EVENTS_FAILURE'
}
